// Ant Design theme configuration
const theme = {
  token: {
    colorPrimary: '#059669',
    colorSuccess: '#059669',
    colorInfo: '#0284c7',
    colorWarning: '#ea580c',
    colorError: '#dc2626',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f8faf9',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif",
    fontSize: 14,
    colorLink: '#059669',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#001529',
    },
  },
};

export default theme;
